<template>
    <modal size="md" class="CampaignConnectChannelModal" @close="close">
        <div class="text-center">
            <div class="m-b-xl">
                <div class="PlatformIcon__wrapper">
                    <platform-icon :platform="platform"></platform-icon>
                </div>
            </div>

            <div class="alert alert-warning">
                Du kan ikke se denne kampagne, fordi du endnu ikke har tilknyttet en
                <b>{{ platform.name }}</b> konto.
            </div>

            <div class="m-t-xl">
                <a href="/settings/channels" class="btn btn-xl btn-success">
                    Tilknyt nu <i class="fa fa-arrow-right"></i>
                </a>
            </div>
        </div>
    </modal>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.CampaignConnectChannelModal {
    .PlatformIcon__wrapper {
        border-radius: 50%;
        width: 100px;
        height: 100px;
        padding: 20px;
        text-align: center;
        border: 2px solid #d6e2eb;
        margin: auto;
    }

    .PlatformIcon {
        font-size: 60px;
    }
}
</style>
<script type="text/babel">
export default {
    props: ['platform'],

    data() {
        return {}
    },

    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>
